module.exports = __webpack_public_path__ + "img/notebook-slash-gray.885439df.svg";